let offCanvasOpen = false;

const toggleOffCanvas = () => {
  offCanvasOpen = !offCanvasOpen;

  $('body').toggleClass(
    'off-canvas-open',
    offCanvasOpen,
  );

  $('body').toggleClass(
    'off-canvas-closed',
    !offCanvasOpen,
  );

  $('body').toggleClass(
    'off-canvas-animating',
    !offCanvasOpen,
  );
};

$('.off-canvas-toggle').on('click', (event) => {
  event.stopPropagation();
  toggleOffCanvas();
});

$('body, .wrapper').on('click', () => {
  if(offCanvasOpen) toggleOffCanvas();
});
